module.exports = {
  siteTitle: 'ShamiArabic.com', // <title>
  manifestName: 'ShamiArabic.com',
  manifestShortName: 'ShamiArabic', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  pathPrefix: `/gatsby-starter-eventually/`, // This path is subpath of your hosting https://domain/portfolio
  // social
  heading: 'Learning Shami Arabic?',
  subHeading:
    "We've put together the best resource for Shami Arabic ever made.",
  socialLinks: [
    {
      icon: 'fa-twitter',
      name: 'Twitter',
      url: 'https://twitter.com/talkin_arabic',
    },
    {
      icon: 'fa-facebook',
      name: 'Facebook',
      url: 'https://www.facebook.com/talkinarabiconline',
    },
  ],
};
